// Supported languages configuration
export interface Language {
  name: string;
  code: string;
  flag: string;
  supported?: boolean; // Optional field to indicate if the language is supported
}

export const LANGUAGES: Language[] = [
  { name: 'Afrikaans', code: 'af', flag: '🇿🇦' },
  { name: 'Albanian', code: 'sq', flag: '🇦🇱' },
  { name: 'Amharic', code: 'am', flag: '🇪🇹' },
  { name: 'Arabic', code: 'ar', flag: '🇸🇦' },
  { name: 'Armenian', code: 'hy', flag: '🇦🇲' },
  { name: 'Auto', code: 'auto', flag: '🌐' },
  { name: 'Azerbaijani', code: 'az', flag: '🇦🇿' },
  { name: 'Bengali', code: 'bn', flag: '🇧🇩' },
  { name: 'Bosnian', code: 'bs', flag: '🇧🇦' },
  { name: 'Bulgarian', code: 'bg', flag: '🇧🇬' },
  { name: 'Canadian French', code: 'fr-CA', flag: '🇨🇦' },
  { name: 'Catalan', code: 'ca', flag: '🇪🇸' },
  { name: 'Chinese', code: 'zh', flag: '🇨🇳' },
  { name: 'Chinese Traditional', code: 'zh-TW', flag: '🇹🇼' },
  { name: 'Croatian', code: 'hr', flag: '🇭🇷' },
  { name: 'Czech', code: 'cs', flag: '🇨🇿' },
  { name: 'Danish', code: 'da', flag: '🇩🇰', supported: true },
  { name: 'Dari', code: 'fa-AF', flag: '🇦🇫' },
  { name: 'Dutch', code: 'nl', flag: '🇳🇱' },
  { name: 'English', code: 'en', flag: '🇬🇧', supported: true },
  { name: 'Estonian', code: 'et', flag: '🇪🇪' },
  { name: 'Finnish', code: 'fi', flag: '🇫🇮', supported: true },
  { name: 'French', code: 'fr', flag: '🇫🇷', supported: true },
  { name: 'Georgian', code: 'ka', flag: '🇬🇪' },
  { name: 'German', code: 'de', flag: '🇩🇪', supported: true },
  { name: 'Greek', code: 'el', flag: '🇬🇷' },
  { name: 'Gujarati', code: 'gu', flag: '🇮🇳' },
  { name: 'Haitian Creole', code: 'ht', flag: '🇭🇹' },
  { name: 'Hausa', code: 'ha', flag: '🇳🇬' },
  { name: 'Hebrew', code: 'he', flag: '🇮🇱' },
  { name: 'Hindi', code: 'hi', flag: '🇮🇳', supported: true },
  { name: 'Hungarian', code: 'hu', flag: '🇭🇺' },
  { name: 'Icelandic', code: 'is', flag: '🇮🇸' },
  { name: 'Indonesian', code: 'id', flag: '🇮🇩' },
  { name: 'Irish', code: 'ga', flag: '🇮🇪' },
  { name: 'Italian', code: 'it', flag: '🇮🇹', supported: true },
  { name: 'Japanese', code: 'ja', flag: '🇯🇵' },
  { name: 'Kannada', code: 'kn', flag: '🇮🇳' },
  { name: 'Kazakh', code: 'kk', flag: '🇰🇿' },
  { name: 'Korean', code: 'ko', flag: '🇰🇷', supported: true },
  { name: 'Latvian', code: 'lv', flag: '🇱🇻' },
  { name: 'Lithuanian', code: 'lt', flag: '🇱🇹' },
  { name: 'Macedonian', code: 'mk', flag: '🇲🇰' },
  { name: 'Malay', code: 'ms', flag: '🇲🇾' },
  { name: 'Malayalam', code: 'ml', flag: '🇮🇳' },
  { name: 'Maltese', code: 'mt', flag: '🇲🇹' },
  { name: 'Marathi', code: 'mr', flag: '🇮🇳' },
  { name: 'Mexican Spanish', code: 'es-MX', flag: '🇲🇽' },
  { name: 'Mongolian', code: 'mn', flag: '🇲🇳' },
  { name: 'Norwegian', code: 'no', flag: '🇳🇴' },
  { name: 'Pashto', code: 'ps', flag: '🇦🇫' },
  { name: 'Persian', code: 'fa', flag: '🇮🇷' },
  { name: 'Polish', code: 'pl', flag: '🇵🇱', supported: true },
  { name: 'Portugal Portuguese', code: 'pt-PT', flag: '🇵🇹' },
  { name: 'Portuguese', code: 'pt', flag: '🇧🇷', supported: true },
  { name: 'Punjabi', code: 'pa', flag: '🇮🇳' },
  { name: 'Romanian', code: 'ro', flag: '🇷🇴' },
  { name: 'Russian', code: 'ru', flag: '🇷🇺' },
  { name: 'Serbian', code: 'sr', flag: '🇷🇸' },
  { name: 'Sinhala', code: 'si', flag: '🇱🇰' },
  { name: 'Slovak', code: 'sk', flag: '🇸🇰' },
  { name: 'Slovenian', code: 'sl', flag: '🇸🇮' },
  { name: 'Somali', code: 'so', flag: '🇸🇴' },
  { name: 'Spanish', code: 'es', flag: '🇪🇸', supported: true },
  { name: 'Swahili', code: 'sw', flag: '🇰🇪' },
  { name: 'Swedish', code: 'sv', flag: '🇸🇪' },
  { name: 'Tagalog', code: 'tl', flag: '🇵🇭' },
  { name: 'Tamil', code: 'ta', flag: '🇮🇳' },
  { name: 'Telugu', code: 'te', flag: '🇮🇳' },
  { name: 'Thai', code: 'th', flag: '🇹🇭' },
  { name: 'Turkish', code: 'tr', flag: '🇹🇷' },
  { name: 'Ukrainian', code: 'uk', flag: '🇺🇦' },
  { name: 'Urdu', code: 'ur', flag: '🇵🇰' },
  { name: 'Uzbek', code: 'uz', flag: '🇺🇿' },
  { name: 'Vietnamese', code: 'vi', flag: '🇻🇳', supported: true },
  { name: 'Welsh', code: 'cy', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿' },
];

export const DEFAULT_DISPLAY_LANGUAGE = 'en';
export const DEFAULT_DISPLAY_LANGUAGE_COUNTRY = 'en-US';

export const getLanguageByCode = (code: string): Language | undefined => {
  return LANGUAGES.find((lang) => lang.code === code);
};

export const getSupportedLanguages = (): Language[] => {
  return LANGUAGES.filter((lang) => lang.supported === true);
};
